






































































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { snackModule, authModule } from '@/store';
import { ContactForm } from '@/api';

@Component({
  components: {},
})
export default class extends Vue {
  loading: boolean = false;
  valid: boolean = false;
  success: boolean = false;
  error: string = '';

  contact: ContactForm | null = null;

  requiredRule = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  emailRules = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',

    (v: string) =>
      v8n()
        .pattern(/\S+@\S+\.\S+/)
        .test(v) || 'Email must be valid',
  ];

  async save() {
    if (!this.contact) {
      return;
    }

    try {
      this.loading = true;
      await this.contact.save();
      this.error = '';
      this.success = true;
    } catch (e) {
      this.success = false;
      this.error = e.response.errors[0].detail;
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    this.contact = new ContactForm();

    if (authModule.isLoggedIn && authModule.user) {
      this.contact.name =
        authModule.user.firstName + ' ' + authModule.user.lastName;
      this.contact.email = authModule.user.email;
      this.contact.phone = authModule.user.phone;
    }
  }
}
